/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Clients.jsx
 * description   : {{insert here}}
 * creation date : 26/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    useComponentContext,
} from '@/components/core';

import {
    ViewPortContainer,
} from '@/components/snippets/CustomDiv';

import {
    ContentContainer,
} from '@/components/snippets/ContentDiv';

import {
    config_page_HOME_clients as page_configuration,
} from '@/components/layouts/core';

import InfoBadge from '@/components/snippets/InfoBadge';

// Images
import ImageClients1 from '@/assets/images/home/robotic-arms-along-assembly-line-in-modern-factory.jpg';
import ImageClients2 from '@/assets/images/home/paris-cdg-aircrafts-in-runway.jpg';
import ImageClients3 from '@/assets/images/home/coeur-defense.jpg';
import ImageClients4 from '@/assets/images/home/facade-immeuble-haussmannien-paris.png';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Clients({ id }) {
    // Component context
    const { ctx } = useComponentContext();

    // Detect private access
    if (false === ctx.api.location.canBeDisplayed(page_configuration)) {
        return null;
    }

    return (
        <Fragment>
            <ContentContainer
                rightAligned={true}
                id={id}
                title='Clients' // TODO: Translate message
            >
                <ViewPortContainer>
                    <InfoBadge
                        BadgeImage={ImageClients1}
                        // TODO: Translate message
                        title='Industrial sites'
                        imageToTheRight={false}
                    >
                        {/* TODO: Translate message */}
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                        arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                    </InfoBadge>

                    <InfoBadge
                        BadgeImage={ImageClients2}
                        // TODO: Translate message
                        title='Airports'
                        imageToTheRight={true}
                    >
                        {/* TODO: Translate message */}
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                        arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                    </InfoBadge>

                    <InfoBadge
                        BadgeImage={ImageClients3}
                        // TODO: Translate message
                        title='Cities'
                        imageToTheRight={false}
                    >
                        {/* TODO: Translate message */}
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                        arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                    </InfoBadge>

                    <InfoBadge
                        BadgeImage={ImageClients4}
                        // TODO: Translate message
                        title='Real estate'
                        imageToTheRight={true}
                    >
                        {/* TODO: Translate message */}
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                        arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                    </InfoBadge>
                </ViewPortContainer>
            </ContentContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Clients;



// End of file
